import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cost-control',
  templateUrl: './cost-control.component.html',
  styleUrls: ['./cost-control.component.scss']
})
export class CostControlComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/cost-control/cost-control.component.ts